/* eslint-disable jira/react-magnetic-di/no-unneeded */
import React, { type ReactNode, type ComponentType } from 'react';
import { di } from 'react-magnetic-di';
import { ClientOnlyNavigationContainers } from './client-only-navigation-containers/index.tsx';
import type { NavigationContainersProps } from './types.tsx';

let Containers: ComponentType<{ children: ReactNode; baseUrl: string }> = ({
	children,
}: {
	children: ReactNode;
}) => <>{children}</>;

if (!__SERVER__) {
	Containers = ClientOnlyNavigationContainers;
}

export const NavigationContainers = ({ baseUrl, children }: NavigationContainersProps) => {
	di(Containers);

	return <Containers baseUrl={baseUrl}>{children}</Containers>;
};
